<div class="flex h-[70vh] gap-3 p-4">
    <!-- THREADS (claude-style): the employee's own conversations, newest first -->
    <div class="flex w-44 shrink-0 flex-col gap-1 overflow-y-auto border-r border-black/10 pr-2">
        <button immoButton type="button" size="sm" outlined theme="surface-container-low" (click)="newThread()">
            {{ 'Assistant.NewThread' | translate }}
        </button>
        @for (thread of threads(); track thread.id) {
        <button type="button"
            class="group flex items-center justify-between gap-1 rounded px-2 py-1.5 text-left text-xs hover:bg-black/5"
            [class.bg-black/10]="activeThreadId() === thread.id" (click)="loadThread(thread.id)">
            <span class="truncate">{{ thread.title }}</span>
            <span class="hidden shrink-0 cursor-pointer opacity-40 hover:opacity-100 group-hover:inline"
                (click)="deleteThread(thread, $event)">✕</span>
        </button>
        }
        <button type="button" class="rounded px-2 py-1.5 text-left text-xs italic opacity-60 hover:bg-black/5"
            [class.bg-black/10]="activeThreadId() === null && !isDraftThread()" (click)="loadThread(null)">
            {{ 'Assistant.LegacyThread' | translate }}
        </button>
    </div>

    <div class="flex min-w-0 flex-1 flex-col gap-3">
    <p class="text-xs opacity-60">{{ 'Assistant.Hint' | translate }}</p>

    <div data-chat-scroll class="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
        @if (!messages().length && !isLoading()) {
        <div class="flex flex-wrap gap-2 py-4">
            @for (key of suggestions; track key) {
            <button type="button" class="rounded-full border px-3 py-1 text-sm hover:bg-black/5"
                (click)="ask(chatInput, key)">{{ key | translate }}</button>
            }
        </div>
        }
        @for (message of messages(); track $index) {
        <div [class]="message.role === 'user'
                ? 'max-w-[85%] self-end rounded-lg bg-violet-100 px-3 py-1.5 text-sm'
                : 'max-w-[85%] self-start rounded-lg bg-black/5 px-3 py-1.5 text-sm'">
            <div class="break-words" [innerHTML]="formatChat(message.content)"></div>
            @if (message.sources?.length) {
            <div class="mt-1.5 flex flex-wrap items-center gap-1">
                <span class="text-xs font-medium opacity-50">{{ 'Assistant.Sources' | translate }}</span>
                @for (source of message.sources; track source.id) {
                <button type="button" class="rounded-full bg-white/70 px-2 py-0.5 text-xs"
                    [class.hover:underline]="isSourceClickable(source)"
                    [disabled]="!isSourceClickable(source)" [title]="source.kind"
                    (click)="openSource(source)">{{ source.title || source.kind }}</button>
                }
            </div>
            }
        </div>
        }
        @if (isChatting()) {
        <p class="flex items-center gap-2 self-start px-3 py-1.5 text-sm opacity-60">
            <span class="inline-block size-3 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"></span>
            <span class="italic">{{ thinkingLine() }}</span>
        </p>
        }
    </div>

    <div class="flex items-center gap-2">
        <input #chatInput type="text" class="min-w-0 flex-1 rounded border px-2 py-1.5 text-sm"
            [placeholder]="'Assistant.Placeholder' | translate" [disabled]="isChatting()"
            (keydown.enter)="send(chatInput)" />
        <button immoButton type="button" size="sm" theme="primary" [disabled]="isChatting()" (click)="send(chatInput)">
            {{ 'Email.Chat.Send' | translate }}
        </button>
        @if (messages().length) {
        <button immoButton type="button" size="sm" outlined theme="surface-container-low" (click)="reset()">
            {{ 'Assistant.Reset' | translate }}
        </button>
        }
    </div>
    </div>
</div>
